import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=08e5d9ea&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=ts"
export * from "./SignUp.vue?vue&type=script&lang=ts"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=08e5d9ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e5d9ea",
  null
  
)

export default component.exports